<template>
  <div id="about">
    <p>Through the <b>Teletraan Alpha Project</b> , 4/25th Paratroopers are receiving training in application development. </p>
        <h2>In development now, 4/25th Paratroopers will be able to place to-go plate orders from the Wilderness Inn Dining Facility.</h2> 
          <br/>
          <p>To be a part of this project or similar opportunities, please contact <u>graham@sparwerx.com</u></p> 
      <h3 style="text-align:center">Check Out These Links</h3>
    <ul style="text-align:center">
      <li>
        <a
          href="https://www.SPARwerx.com"
          target="_blank"
          rel="noopener"
        >The 4/25th Brigade Innovation Initiative</a>
      </li>
      <li>
        <a
          href="https://PMCSx.SPARwerx.com"
          target="_blank"
          rel="noopener"
        >PMCSx - Your new Digital 5988</a>
      </li>
    </ul>
    </div>
</template>

<script>
export default {
  name: 'About'
};
</script>

<style lang="scss" scoped>
#about {

}
</style>